import { useState } from "react";
import {useTranslation} from "react-i18next";

const AccordionList = () => {

    const { t } = useTranslation();

    const accordionItems = [
        {
            title: t('servicesPage.faq1.question'),
            content: t('servicesPage.faq1.answer')
        },
        {
            title: t('servicesPage.faq2.question'),
            content: t('servicesPage.faq2.answer')
        },
        {
            title: t('servicesPage.faq3.question'),
            content: t('servicesPage.faq3.answer')
        },
        {
            title: t('servicesPage.faq4.question'),
            content: t('servicesPage.faq4.answer')
        },
        {
            title: t('servicesPage.faq5.question'),
            content: t('servicesPage.faq5.answer')
        },
        {
            title: t('servicesPage.faq6.question'),
            content: t('servicesPage.faq6.answer')
        }
    ]

    const [activeIndex, setActiveIndex] = useState<number>(0);
    


    return (
        <div className="accordion" id="accordionExample">
            {accordionItems.map((item, index) => (
                <div className="accordion-item p-3" key={index} onClick={() => setActiveIndex((prev) => index === activeIndex ? prev : index)}>
                    <div className="d-flex justify-content-between align-items-center">
                        <h5>{item.title}</h5>
                        <i>{index === activeIndex ? "-" : "+"}</i>
                    </div>
                    {index === activeIndex && (
                        <p className="mb-0">{item.content}</p>
                    )}
                </div>
            ))}
        </div>
    );
}

export default AccordionList;